var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-chart',{attrs:{"chart-data":_vm.dataCollection,"styles":_vm.chartStyles,"options":_vm.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }